import type { ReactNode } from 'react';

import {
  Popover,
  PopoverTrigger,
  IconButtonGroup,
  IconButton,
  OutlineCircleInfoIcon,
  Portal,
} from '@frontend/components';

type InfoPopoverProps = {
  children: ReactNode;
  popoverBoundaryElement?: HTMLElement | null;
};

export const InfoPopover = ({
  children,
  popoverBoundaryElement,
}: InfoPopoverProps) => {
  return (
    <Popover size="md" boundary={popoverBoundaryElement || undefined}>
      {({ isOpen }) => (
        <>
          <IconButtonGroup>
            <PopoverTrigger>
              <IconButton isActive={isOpen} m={0}>
                <OutlineCircleInfoIcon />
              </IconButton>
            </PopoverTrigger>
          </IconButtonGroup>
          <Portal>{isOpen && children}</Portal>
        </>
      )}
    </Popover>
  );
};

InfoPopover.displayName = 'InfoPopover';
